import Cookies from "js-cookie"

import { IS_PRODUCTION_OR_STAGING } from "./environment"
import { type ConsentId, isConsentGranted } from "./consent"

interface ExtendedCookies extends Omit<Cookies.CookiesStatic, "set"> {
  setAtUserRequest: typeof Cookies.set
  setIfConsent(
    consentId: ConsentId,
    name: string,
    value: string,
    options?: Cookies.CookieAttributes
  ): string | undefined
}

const cookiesWithAttributes = Cookies.withAttributes({
  samesite: "lax",
  secure: IS_PRODUCTION_OR_STAGING
})

const cookiesWithConsent: ExtendedCookies = Object.assign(Object.create(cookiesWithAttributes), {
  set: null,

  // Explicit function to denote user-requested action that does not require consent.
  setAtUserRequest: cookiesWithAttributes.set.bind(cookiesWithAttributes),

  setIfConsent: (
    consentId: ConsentId,
    name: string,
    value: string,
    options?: Cookies.CookieAttributes
  ): string | undefined => {
    if (isConsentGranted(consentId)) {
      return cookiesWithAttributes.set(name, value, options)
    }
  }
})

export default cookiesWithConsent
